export const ApiName = {
  generateToken: "authenticate",
  getFlow: "getFlow",
  awarenessFlow: "awarenessFlow",
  subscribe: "subscribe",
  ffSubscribe: "ffSubscribe",
  utmList: "utmList",
  sendOtp: "sendOtp",
  checkOperator: "checkOperator",
  checkHe: "checkHe",
  decrypt:"decrypt",
  // easy paisa
  epGenerateOtp: "epGenerateOtp",
  epVerifyLinkOtp:"epVerifyLinkOtp",
  epGenerateOtpOrganic:"epGenerateOtpOrganic",
  epVerifyLinkOtpOrganic:"epVerifyLinkOtpOrganic",
  epDecrypt:"epDecrypt",
  checkUserSubscriptions:"checkUserSubscriptions"
};
